import {apiRoutes, BASE_URL} from "../api-config";

export const GetContacts = async () =>{
    const result = await fetch(`${BASE_URL}/${apiRoutes.CONTACTS}/1`)
    return result.json()
}